/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import "App.css";
// Data
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { deleteUser, getUsers } from "../../actions/users/user";
import { toast } from "react-toastify";
import Footer from "../authentication/components/Footer";
import Paginate from "../../components/Paginate/Paginate";
import { ShimmerPostList } from "react-shimmer-effects";
import { decryptAndRetrieve } from "../../utils/user_data";
function Tables() {
  const columns = [
    { Header: "نام کاربری", accessor: "username", align: "center" },
    { Header: "نام", accessor: "name", align: "center" },
    { Header: "کد ملی", accessor: "melli_code", align: "center" },
    { Header: "تاریخ تولد", accessor: "birthday", align: "center" },
    { Header: "موقعیت", accessor: "position", align: "center" },
    { Header: "نقش", accessor: "role", align: "center" },
  ];

  const [users, setUsers] = useState({ data: [], links: {} });
  const [loading, setLoading] = useState(true);
  const [status, setStatusDelete] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const userData = decryptAndRetrieve('bargo');
  async function deleteUsers(id) {
    const deletes = await deleteUser(id);
    if (deletes.status === "success") {
      toast.success("کاربر حذف شد!");
      setStatusDelete(true);
    } else {
      toast.error("خطا در حذف کاربر");
    }
  }

  useEffect(() => {
    const fetchApi = async () => {
      const params = new URLSearchParams(searchParams);
      try {
        const usersData = await getUsers(params.toString());
        setLoading(false);
        if (usersData.status !== "error") {
          const filteredUsers = usersData.message.data.filter(
            (user) => user.username !== "superadmin"
          );

          const formattedRows = filteredUsers.map((user) => ({
            username: user.username,
            name: user.name,
            melli_code: user.melli_code,
            birthday: user.birthday,
            position: user.position,
            role: user.role === 0 ? "کاربر اپلیکیشن" : "ادمین",
          }));

          setUsers({ data: formattedRows, links: usersData.message.links });
        } else {
          setUsers({ data: [], links: {} });
        }
      } catch (error) {
        toast.error("خطا در اتصال به سرور!");
        setLoading(false);
      }
    };

    fetchApi();
  }, [searchParams,status]);
  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  لیست کاربران
                </MDTypography>
                {
                  userData === 'superadmin' && (<Link
                    to="/users/create"
                    className="mt-5 inline-flex text-sm items-center justify-center rounded-md bg-black px-2 py-3 text-center font-medium text-white hover:bg-opacity-90 lg:px-4 xl:px-6"
                  >
                    افزودن کاربر جدید
                  </Link>)
                }

              </MDBox>

              <MDBox pt={3}>
                {loading ? (
                  <ShimmerPostList postStyle="STYLE_SIX" col={1} row={1} gap={30} />
                ) : (
                  <DataTable
                    table={{ columns, rows: users.data }}
                    isSorted={true}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    loading={loading}
                    noEndBorder
                    canSearch={true}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <div className={"flex justify-center items-center"}>
        {users.data.length > 0 && <Paginate links={users.links} />}
      </div>
      <br />
      <Footer dark />
    </DashboardLayout>
  );
}

export default Tables;
